import React from 'react';

const StepContainer = ({ heading, subheading, children, error }) => (
  <>
    <div className="heading">{heading}</div>
    <div className="subheading">{subheading}</div>
    {children}
    {error && <div className="error mb2">{error}</div>}
  </>
);

export default StepContainer;
